import { FEATURED_PICKS } from "@/mocks/home";
import Reveal from "./Reveal";
import SectionHead from "./SectionHead";

export default function Featured() {
  return (
    <section id="featured" className="w-full bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <Reveal>
          <SectionHead
            index="02"
            kicker="Editor's Picks"
            title="天涯热帖 · 编辑精选"
            desc="编辑部从论坛热帖与话题里逐篇挑出来的深度长文，配图封面先行，适合泡上一杯茶慢慢读。"
            action="进入热帖精选"
          />
        </Reveal>

        <div className="mt-7 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {FEATURED_PICKS.map((f, i) => (
            <Reveal key={f.id} delay={i * 60}>
              <article className="group flex h-full cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-background-300">
                <div className="relative h-40 w-full overflow-hidden md:h-44">
                  <img
                    src={f.image}
                    alt={`海角网热帖精选：${f.title}`}
                    title={`${f.title} · 天涯热帖精选`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />
                  <span className="absolute left-3 top-3 flex items-center gap-1 rounded-full bg-background-50/95 px-2.5 py-1 text-[10px] font-black tracking-wide text-primary-600">
                    <i className="ri-bookmark-fill text-[10px]" />
                    {f.kicker}
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-4">
                  <h3 className="editorial-title text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
                    {f.title}
                  </h3>
                  <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{f.excerpt}</p>
                  <span className="mt-3 inline-flex items-center gap-1 text-xs font-bold text-primary-500">
                    去读全文
                    <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
                  </span>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}